import React from 'react';
interface LogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}
export function Logo({
  variant = 'dark',
  className = ''
}: LogoProps) {
  const src = variant === 'light' ? 'https://cdn.magicpatterns.com/uploads/jjmyAfsTVDBworZww9qTYu/iilh-horizontal-reverse.svg' : 'https://cdn.magicpatterns.com/uploads/nk94tRdfyz62D3w82QLs9V/iilh-short.svg';
  const sizeClasses = variant === 'light' ? 'h-16 md:h-20' : 'h-12 md:h-14';
  return <img src={src} alt="IILH — International Islamic Learning Hub" className={`${sizeClasses} w-auto self-start -ml-2 select-none ${className}`} draggable={false} data-id="element-774" data-mp="itbvfrbyarof" />;
}